import React, { Component } from 'react';

import CdsFeatureItem from "./CdsFeatureItem";

import LockScreen from "./LockScreen";

export default class CdsFeatures extends Component {

    constructor(props) {
        super(props);

        this.getRowsData = this.getRowsData.bind(this);
        this.RenderRow = this.RenderRow.bind(this);
        this.handleToggle = this.handleToggle.bind(this);

        this.state = {
            groups: this.props.groups,
            isLocked: false,
        };
    }

    handleLock = (islock) => {
        this.setState({ isLocked: islock });
    };

    handleToggle = (e) => {
        let groups = this.state.groups;
        const ind = e.currentTarget.getAttribute("index");
        const isActive = groups[ind].isActive;
        groups[ind].isActive = isActive == undefined ? false : !isActive;

        this.setState({ groups: groups });
    };

    getRowsData = function (features, rows) {
        let _rows = rows;
        try {
            rows.sort((a, b) => Number(a.sequence.toString().replace(',', '.')) > Number(b.sequence.toString().replace(',', '.')) ? 1 : -1)
        }
        catch { }

        return _rows
            .map((row, index) => {
                let res = this.RenderRow(this.props.handleUpdate, this.props.updateConfiguration, this.props.configurationId, this.props.cdsId, features, index, row.columns, this.props.extDisable);
                if (res.cnt > 0) {
                    return (
                        <table key={row.id}>
                            <tr>
                                {res.res}
                            </tr>
                        </table>)
                }
                //else {
                //    return ("");
                //}

                //return <table>
                //    <tr>
                //        <RenderRow handleUpdate={this.props.handleUpdate} updateConfiguration={this.props.updateConfiguration}
                //            configurationId={this.props.configurationId} cdsId={this.props.cdsId} features={features}
                //            key={index} columns={row.columns} extDisable={this.props.extDisable} />
                //    </tr>
                //</table>
            })
    }

    render() {
        const debug = this.props.debug;
        const groups = this.state.groups;
        const features = this.props.features;

        return (
            <LockScreen isLocked={this.state.isLocked}>
                <div className="features" >
                    <table>
                        <tbody>
                            {groups.map((group, index) => (
                                <tr class="cdsFeatureItem" >
                                    <td>
                                        <button type="button" onClick={this.handleToggle} index={index} >
                                            <table>
                                                <tbody>
                                                    <tr className="urdUnitHeader">
                                                        <td>
                                                            {group.label}
                                                        </td>
                                                        {/*<td className="selOptFeaPlusMinus">*/}
                                                        {/*    <div>*/}
                                                        {/*        <span>{group.isActive == true || group.isActive == undefined ? "-" : "+"} </span>*/}
                                                        {/*    </div>*/}
                                                        {/*</td>*/}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </button>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {/*<div style={group.isActive == true || group.isActive == undefined ? { display: "block" } : { display: "none" }}>*/}
                                                        {this.getRowsData(features, group.rows)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </LockScreen>
        );
    }

    RenderRow = function (handleUpdate, updateConfiguration, configurationId, cdsId, features, key, columns, extDisable) {
        let cnt = 0;
        let res = columns.map((key, index) => {
            if (key.idCDSParameter != null) {

                let f = features.find(feature => { return feature.id === key.idCDSParameter });
                //if (f == undefined) {
                //    console.log(key.idCDSParameter);
                //}

                if (f !== null && f !== undefined && (f.visible == undefined || f.visible == true)) {
                    let difference = "";
                    let differenceCDS = {};
                    if (f.type == 'numericUpDown') {
                        if (f.difference != "" && f.difference != undefined && f.difference > 0 && f.differenceCDSId != undefined) {
                            difference = f.difference;
                            differenceCDS = features.find(feature => { return feature.id === f.differenceCDSId });
                        }
                    }

                    cnt++;

                    return <td className="cdsCell" colSpan={key.columnSpan}><CdsFeatureItem extDisable={extDisable} configurationId={configurationId}
                        cdsId={cdsId} autoSize={key.autoSize} feature={f}
                        handleUpdate={handleUpdate} updateConfiguration={updateConfiguration}
                        difference={difference} differenceDescription={differenceCDS.description}
                        handleLock={this.handleLock} showError={this.props.showError}
                    /></td>
                }
                else {
                    //return <td className="cdsCell" colSpan={key.columnSpan}></td>
                }
            } else {
                return <td className="cdsCell" colSpan={key.columnSpan}></td>
            }
        })

        return { "res": res, "cnt": cnt };
    }

}

//const RenderRow = (props) => {
//    return props.columns.map((key, index) => {
//        if (key.idCDSParameter != null) {

//            let f = props.features.find(feature => { return feature.id === key.idCDSParameter });
//            if (f == undefined) {
//                console.log(key.idCDSParameter);
//            }

//            if (f !== null && f !== undefined && (f.visible == undefined || f.visible == true)) {
//                let difference = "";
//                let differenceCDS = {};
//                if (f.type == 'numericUpDown') {
//                    if (f.difference != "" && f.difference != undefined && f.difference > 0 && f.differenceCDSId != undefined) {
//                        difference = f.difference;
//                        differenceCDS = props.features.find(feature => { return feature.id === f.differenceCDSId });
//                    }
//                }
//                return <td className="cdsCell" colSpan={key.columnSpan}><CdsFeatureItem extDisable={props.extDisable} configurationId={props.configurationId}
//                    cdsId={props.cdsId} autoSize={key.autoSize} feature={f}
//                    handleUpdate={props.handleUpdate} updateConfiguration={props.updateConfiguration}
//                    difference={difference} differenceDescription={differenceCDS.description}
//                /></td>
//            }
//            else {
//                //return <td className="cdsCell" colSpan={key.columnSpan}></td>
//            }
//        } else {
//            return <td className="cdsCell" colSpan={key.columnSpan}></td>
//        }
//    })
//}
